const theme = {
  colors: {
    primary: "#000000",
    secondary: "#17514E"
  }
}

export default theme
